export enum ShippingLabelFormat {
  PDF = 'PDF',
  ZPL = 'ZPL',
}
